<template>
  <a :href="url">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/variables";

  a {
    display: inline-block;
    background-color: $ocean;
    color: $white;
    padding: 20px;
    min-width: 150px;
    border-radius: 9999px;
    text-decoration: none;
    font-size: 14px;
    margin: 10px;
  }
</style>
